import React, { useState, useEffect } from "react";
import { compose } from "recompose";
import { Table, Button, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
    EditDeleteButtons,
    withTable,
    InviteButton
  } from "components/common/Tables/index";
import Page from "components/common/Page";
import { Trans, useTranslation } from "react-i18next";
import BackButton from "components/refactoring/BackButton";
import { formatDateTime } from "services/util";

export const List = ({
  selected,
  match,
  toggleDeleteModal,
  client,
  ordering,
  url = "notifications?type=announcement",
  data,
  setData,
  limit,
  offset,
  search,
  onDeleteItem,
  onDeleted,
  refreshToken,
  readOnly,
  isDeleteModalOpen
}) => {
    const [announcements, setAnnouncements] = useState([]);
    const [showArchived, setShowArchived] = useState(false);
    const { t } = useTranslation();
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmItem, setConfirmItem] = useState(null);
  
    const fetchAnnouncements = async () => {
        try {
          const response = await client.get('notifications', { params: { type: 'announcement', status: showArchived ? 'Archived' : 'Active' } })
          setAnnouncements(response.data);
        } catch (error) {
          console.error("Error fetching notifications:", error);
        }
      };

    useEffect(() => { 
      fetchAnnouncements();
      return () => {
        setAnnouncements([]);
      };
    }, [showArchived]);

    const archiveNotification = async (id) => {
      try {
        await client.post(`notifications/${id}/archive`);
        fetchAnnouncements();
      } catch (error) {
        console.error("Error archiving notification:", error);
      }
    };

    const unarchiveNotification = async (id) => {
      try {
        await client.post(`notifications/${id}/unarchive`);
        fetchAnnouncements();
      } catch (error) {
        console.error("Error unarchiving notification:", error);
      }
    };

  return (
        
    <Page title="Announcements" className="inv-table">
      <BackButton/>
      <InviteButton
        resource="Announcement"
        match={match}
        className="float-left mb-3 mx-0"
        readOnly={readOnly}
      >Create</InviteButton>
      <div className="float-right mb-3">
        <CustomInput type="checkbox" id="showArchived" label={t('Show Archived')} checked={showArchived} onChange={(e) => setShowArchived(e.target.checked)} />
      </div>
      <div>

        <Table size="" className="">
          <thead>
            <tr>
              <th className="text-left">
                <Trans>Title</Trans>
              </th>
              <th>
                <Trans>Message</Trans>
              </th>
              <th>
                <Trans>Created At</Trans>
              </th>
              <th>
                <Trans>Actions</Trans>
              </th>
            </tr>
          </thead>
          <tbody>
              {announcements?.map((notification) => (
                <tr key={notification.id}>
                  <td>{notification.title}</td>
                  <td>{notification.message}</td>
                  <td>{ formatDateTime(notification.created_at)}</td>
                  <td>
                    {notification?.status === 'Active' && <EditDeleteButtons
                      url={match.url}
                      id={notification.id}
                      readOnly={readOnly}
                    />}
                    {notification?.status === 'Archived' ? (
                      <Button size="sm" color="secondary" className="ml-2" onClick={() => unarchiveNotification(notification.id)}>
                        <Trans>Unarchive</Trans>
                      </Button>
                    ) : (
                      <Button size="sm" color="warning" className="ml-2" onClick={() => { setConfirmItem(notification); setConfirmOpen(true); }}>
                        <Trans>Archive</Trans>
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
        </Table>
      </div>
      <Modal isOpen={confirmOpen} toggle={() => setConfirmOpen(false)}>
        <ModalHeader toggle={() => setConfirmOpen(false)}>{t('Confirm Archive')}</ModalHeader>
        <ModalBody>
          {t('Are you sure you want to archive this announcement?')}
          <div className="mt-2"><strong>{confirmItem?.title}</strong></div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setConfirmOpen(false)}>{t('Cancel')}</Button>
          <Button color="warning" onClick={async () => { await archiveNotification(confirmItem.id); setConfirmOpen(false); setConfirmItem(null); }}>{t('Archive')}</Button>
        </ModalFooter>
      </Modal>
    </Page>
)};


const enhance = compose(withTable({ limit: 100 }));

export default enhance(List);
